import {AssemblyScreen} from "./AssemblyScreen";
import {RobotModel, RobotSlot} from "../GameObjects/Assembly/RobotModel";
import {Dict} from "../Core/Reflection";
import {IPoint} from "../Core/Geom";
import {MonsterModel} from "../GameObjects/Assembly/MonsterModel";
import {stopVO} from "../Data/VoiceOver";

export class RobotScreen extends AssemblyScreen<RobotSlot> {

    init(pSize: PIXI.Point, model: RobotModel) {
        super.init(pSize, model);
        this.buttons.forEach(it => it.clickSfx = "robot-button");
        this.buttons.forEach(it => it.hoverAnchor = {x: it.x < 0 ? 0 : 1, y: 0.5});
        this.setButtonsPosition(pSize);
    }

    onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.setButtonsPosition(pSize);
    }

    private setButtonsPosition(pSize: IPoint) {
        this.buttons.forEach(it => it.setPosition(pSize));
    }

    protected getStartVO(): (string | number)[] | undefined {
        return ["LetsGoLuna_070"];
    }

    protected getSlotHoverVO(): Dict<RobotSlot, string> | undefined {
        return {
            [RobotSlot.Body]: "LetsGoLuna_073",
            [RobotSlot.Head]: "LetsGoLuna_071",
            [RobotSlot.LeftArm]: "LetsGoLuna_072",
            [RobotSlot.RightArm]: "LetsGoLuna_072",
            [RobotSlot.LeftLeg]: "LetsGoLuna_082",
            [RobotSlot.RightLeg]: "LetsGoLuna_082",
        };
    }

    protected getAssemblyCompleteVO(): string[] | undefined {
        return [
            "LetsGoLuna_074",
            "LetsGoLuna_075",
            "LetsGoLuna_076",
            "LetsGoLuna_077"
        ];
    }

    protected getFactVO(): string[] | undefined {
        return [
            "LetsGoLuna_078",
            "LetsGoLuna_079"
        ];
    }

    protected returnHome(model: RobotModel, submitted: boolean) {
        if (submitted) {
            this.buttonOk.enabled = false;
            this.buttonOk.stopPulse();
            this._factsDisabled = true;
            stopVO();
            this.playCompleteVO(() => this.superReturnHome(model, submitted));
        } else {
            this.superReturnHome(model, submitted);
        }
    }

    private superReturnHome(model: MonsterModel, submitted: boolean) {
        super.returnHome(model, submitted);
    }
}